// import TweenMax from 'TweenMax';
import TimelineMax from 'TimelineMax';
import ScrollMagic from 'ScrollMagic';
import 'animation.gsap';

export const whitening = (triggerElement) => {
  const controller = new ScrollMagic.Controller();
  const tween = new TimelineMax();

  tween.fromTo(
    triggerElement,
    1.5,
    {autoAlpha: 1},
    {autoAlpha: 0.3}
  );

  new ScrollMagic.Scene({
    triggerElement,
    offset: window.innerHeight
  })
    .setTween(tween)
    .addTo(controller);
};

export const parallaxY = (triggerElement, targetElement) => {
  const controller = new ScrollMagic.Controller();
  const tween = new TimelineMax();

  tween.fromTo(
    targetElement,
    1,
    {yPercent: 0},
    {yPercent: 10}
  );

  new ScrollMagic.Scene({
    triggerElement,
    triggerHook: 'onLeave',
    duration: '100%',
    offset: 0
  })
    .setTween(tween)
    .addTo(controller);
};

// export const parallaxY3D = (triggerElement, targetElement) => {
//   const controller = new ScrollMagic.Controller();
//
//   const move = (progress) => {
//     const to = progress * 80;
//     TweenMax.to(
//       targetElement,
//       0.3,
//       {y: `${to}%`, overwrite: 5, force3D: true}
//     );
//   };
//
//   new ScrollMagic.Scene({
//     triggerElement
//   })
//     .on('progress', (e) => move(e.progress))
//     .addTo(controller);
// };

export const fadeInUp = (triggerElement, targetElement) => {
  const controller = new ScrollMagic.Controller();
  const tween = new TimelineMax();

  tween.fromTo(
    targetElement,
    0.75,
    {y: 50, autoAlpha: 0},
    {y: 0, autoAlpha: 1}
  );

  new ScrollMagic.Scene({
    triggerElement,
    offset: 0
  })
    .setTween(tween)
    .addTo(controller);
};

export const pressFadeInUp = (triggerElement, targetElement) => {
  const controller = new ScrollMagic.Controller();
  const tween = new TimelineMax();

  tween.staggerFromTo(
    targetElement,
    0.75,
    {y: 50, autoAlpha: 0},
    {y: 0, autoAlpha: 0.4},
    0.2
  );

  new ScrollMagic.Scene({
    triggerElement,
    triggerHook: 'onEnter',
    offset: 300
  })
    .setTween(tween)
    .addTo(controller);
};


// WEBPACK FOOTER //
// ./src/lib/functions/SceneEffects.js